import { Icon, type IconProps } from '@repo/ui/Icon';

type RecipeToastContent = {
  message: string;
  icon: IconProps['name'];
};

export const ToastRecipeContent = ({ message, icon }: RecipeToastContent) => (
  <>
    <Icon name={icon} size="sm" />
    {message}
  </>
);
